import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Label as RACLabel } from 'react-aria-components';
import { twMerge } from '../../utils/twMerge.js';
/**
 * Styled react-aria `<Label>` element. Meant to be used as part of an input field. Should only be used directly when constructing custom input types.
 */
export const Label = forwardRef(function Label(props, forwardedRef) {
    return (_jsx(RACLabel, { ...props, ref: forwardedRef, className: twMerge('ppl-Label flex flex-row gap-1 text-body-md font-medium text-default-subdued', props.className) }));
});
//# sourceMappingURL=Label.js.map